define(function(require) {

    const _ = require('underscore');
    const i18n = require('i18n');
    const server = require('server');
    const LimitsModel = require('portlets/responsible-gaming/limits/limits.model');
    const limitsConfig = require('portlets/responsible-gaming/limits/limits.config');
    const depositLimitsConfig = require('modules/deposit-limits-config/deposit.limits.config.instance');

    return LimitsModel.extend({
        /**
         * Format pending (waiting) deposit|loss|bet limits
         * @param  {Object}     data    model attributes
         * @return {Object}             model attributes
         */
        _formatWaitingData: function(data) {
            const waitings = limitsConfig().waiting;
            const waitingLimits = data.waitingLimits;
            const { formatCurrency, getDateTimeShort, parseImsDate } = window.Playtech.API.formatter;

            if (waitingLimits) {
                var waitingDepositLimits = {
                    waitingdaydepositlimit: waitingLimits.find(waitingLimit => waitingLimit.timePeriod === 'daily'),
                    waitingweekdepositlimit: waitingLimits.find(waitingLimit => waitingLimit.timePeriod === 'weekly'),
                    waitingmonthdepositlimit: waitingLimits.find(waitingLimit => waitingLimit.timePeriod === 'monthly')
                };

                _.extend(data, waitingDepositLimits);
            }

            _.each(waitings, waiting => {
                const value = data[waiting.value];
                const amount = value?.amount?.amount;
                const currencyCode = value?.amount?.currencyCode || this.get('defaultCurrency');
                const isValue = value || value === 0;
                const isAmount = amount || amount === 0;

                if (isAmount || isValue) {
                    data[waiting.availability] = true;

                    if (isAmount) {
                        let waitAmountTranslation = amount >= depositLimitsConfig.UNLIMITED_AMOUNT
                            ? i18n.t('playtech.mobile.ngresponsiblegaming.limits.unlimited')
                            : formatCurrency(amount, { currencyCode });

                        data[waiting.value] = {
                            date: data[waiting.date].startDate ? getDateTimeShort(parseImsDate(data[waiting.date].startDate)) : '',
                            title: i18n.t('playtech.mobile.ngresponsiblegaming.limits.waiting.' + data[waiting.period].timePeriod, waitAmountTranslation)
                        };
                    } else {
                        const waitValueTranslation = value >= depositLimitsConfig.UNLIMITED_AMOUNT
                            ? i18n.t('playtech.mobile.ngresponsiblegaming.limits.unlimited')
                            : data[waiting.value] === 0
                                ? i18n.t('playtech.mobile.ngresponsiblegaming.limits.notdefined')
                                : formatCurrency(data[waiting.value], { currencyCode });

                        data[waiting.value] = {
                            date: data[`${waiting.date}date`] ? getDateTimeShort(data[`${waiting.date}date`]) : '',
                            title: i18n.t('playtech.mobile.ngresponsiblegaming.limits.waiting.' + waiting.period, waitValueTranslation)
                        };
                    }

                    data[waiting.value] = {
                        ...data[waiting.value],
                        timePeriod: value?.timePeriod,
                        confirmationNeeded: value?.confirmationNeeded
                    };
                }
            });

            ['waitingdaydepositlimit', 'waitingweekdepositlimit', 'waitingmonthdepositlimit'].forEach(limit => {
                if (data[limit]) {
                    data[limit].isDepositType = true;
                }
            });

            return data;
        },

        getDepositLimitsPeriodData: function(data) {
            const limits = [];
            const typeMap = {
                daydepositlimit: 'daily',
                weekdepositlimit: 'weekly',
                monthdepositlimit: 'monthly'
            };

            for (var key in data) {
                limits.push({
                    amount: data[key],
                    timePeriod: typeMap[key]
                });
            }

            return limits;
        },

        fetchDepositLimitInfo: function() {
            const isDepositEnabled = this.get('depositConfig').isDepositListEnabled;

            if (isDepositEnabled) {
                return server.send({
                    ID: 89901,
                    description: 'Get Deposit Limits',
                    correlationId: _.uniqueId('get-deposit-limits'),
                    responses: [89905, 89900]
                })
                    .then(function(response) {
                        const waitingLimitsArr = response && response.data && response.data.waitingLimits;

                        if (waitingLimitsArr && waitingLimitsArr.length > 0) {
                            waitingLimitsArr.forEach(function(item) {
                                if (item.confirmationNeeded && item.confirmationNeeded === 1) {
                                    const action = 'accept';
                                    this.acceptPlayerDepositLimits(action, item.timePeriod)
                                        .catch((error) => {
                                            const { errorMessage, userErrors } = error?.response?.data || {};

                                            this.$('.fn-pending-limits-messages').html(
                                                userErrors?.[0]?.message
                                                || errorMessage
                                                || this.translate('playtech.mobile.ngresponsiblegaming.limits.generic.error')
                                            ).removeClass('hidden');
                                        });
                                }
                            }.bind(this));
                        }
                    }.bind(this)).done(function() {
                        return server.send({
                            ID: 89901,
                            description: 'Get Deposit Limits',
                            correlationId: _.uniqueId('get-deposit-limits'),
                            responses: [89905, 89900]
                        }).then(function(response) {
                            this.set({ fetchedDepositLimits: this.parse(response) });
                        }.bind(this));
                    }.bind(this));
            }
        }
    });
});
